import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FormattedMessage } from "react-intl";

export default function VacationPage() {
  return (
    <section className="mx-auto flex w-full max-w-3xl flex-col gap-6 p-4 md:p-8">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight text-primary">
          <FormattedMessage id="vacation.title" />
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          <FormattedMessage id="vacation.description" />
        </p>
      </div>

      <div className="rounded-lg border bg-card p-5 shadow-sm">
        <div className="grid gap-4 md:grid-cols-2">
          <div className="space-y-2">
            <Label htmlFor="vacation-start">
              <FormattedMessage id="vacation.startDate" />
            </Label>
            <Input id="vacation-start" type="date" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="vacation-end">
              <FormattedMessage id="vacation.endDate" />
            </Label>
            <Input id="vacation-end" type="date" />
          </div>
        </div>
        <p className="mt-4 text-sm text-muted-foreground">
          <FormattedMessage id="vacation.note" />
        </p>
      </div>
    </section>
  );
}
